<template>
  <div v-if="Object.keys(buttonsNames).length">
    <b-form-radio-group
      v-model="phaseFeederSelection"
      :name="name"
      stacked
      buttons
      button-variant="outline"
    >
      <b-row>
        <b-col v-if="Object.keys(buttonsNames.phases).length" md="auto">
          <p class="visnet-events__filters-type">Phase:</p>
          <b-form-radio
            v-for="phaseName in buttonsNames.phases"
            :key="phaseName.label"
            :value="phaseName.value"
            class="custom-check-button"
            @change="selectPhaseFeeder"
          >
            {{ phaseName.label }}
          </b-form-radio>
        </b-col>
        <b-col v-if="Object.keys(buttonsNames.feeders).length" md="auto">
          <p class="visnet-events__filters-type">Feeder:</p>
          <b-form-radio
            v-for="feederName in buttonsNames.feeders"
            :key="feederName.label"
            v-b-popover.hover.html.topleft="generateFeederName(feederName.value)"
            :value="feederName.value"
            class="custom-check-button"
            @change="selectPhaseFeeder"
          >
            {{ feederName.label }}
          </b-form-radio>
        </b-col>
      </b-row>
    </b-form-radio-group>
  </div>
  <div v-else>
    No data
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DateMethods from '@/components/mixins/date-methods';

const STORE_ACTIONS = {
  ELECTRICAL: {
    RESET_SERIES: 'electricalData/resetElectricalSeries',
    SET_PHASES_FEEDERS: 'electricalData/setPhaseFeeder',
    FETCH_DATA: 'electricalData/fetchElectricalData'
  },
  POWER_QUALITY: {
    RESET_SERIES: 'powerQualityData/resetPowerQualitySeries',
    SET_PHASES_FEEDERS: 'powerQualityData/setPhaseFeeder',
    FETCH_DATA: 'powerQualityData/fetchPowerQualityData'
  }
};
const DEFAULT_SELECTION = { value: 0, group: 'feeder' };

export default {
  name: 'PhasesFeeders',
  mixins: [DateMethods],
  props: {
    name: String,
    buttonsNames: Object,
    activeTimeView: { type: Number, required: true },
    date: { type: String, required: true }
  },
  data() {
    return {
      phaseFeederSelection: DEFAULT_SELECTION,
      showCollapse: false
    };
  },
  computed: {
    ...mapState({
      feederNames: state => state.substationVisnetHub.visnetHub.ways
    }),
    ...mapGetters({
      electricalAttributes: 'electricalData/electricalAttributes',
      powerQualityAttributes: 'powerQualityData/powerQualityAttributes'
    }),
    isElectrical() {
      return this.name === 'ElectricalFiltration';
    },
    mappedResetDataMutation() {
      return this.isElectrical
        ? STORE_ACTIONS.ELECTRICAL.RESET_SERIES
        : STORE_ACTIONS.POWER_QUALITY.RESET_SERIES;
    },
    mappedSetSelectedPhaseFeeder() {
      return this.isElectrical
        ? STORE_ACTIONS.ELECTRICAL.SET_PHASES_FEEDERS
        : STORE_ACTIONS.POWER_QUALITY.SET_PHASES_FEEDERS;
    },
    mappedFetchData() {
      return this.isElectrical
        ? STORE_ACTIONS.ELECTRICAL.FETCH_DATA
        : STORE_ACTIONS.POWER_QUALITY.FETCH_DATA;
    }
  },
  watch: {
    activeTimeView: {
      handler: function handlerChanged() {
        this.selectPhaseFeeder(this.phaseFeederSelection);
      },
      immediate: true
    },
    date() {
      this.selectPhaseFeeder(this.phaseFeederSelection);
    }
  },
  methods: {
    generateFeederName(feederValue) {
      const foundFeeder = this.feederNames.find(
        feederName => feederName.number === feederValue.value
      );

      return !foundFeeder ? '' : `<div>${foundFeeder.name}</div>`;
    },
    async selectPhaseFeeder(selected) {
      this.$store.commit(this.mappedResetDataMutation);
      this.$store.commit(this.mappedSetSelectedPhaseFeeder, selected);

      const { externalVisnetHubId, projectCode, substationCode } = this.$route.params;
      const { startDate, endDate } = this.selectTimespan(this.activeTimeView, this.date);
      const { group, value } = selected;

      const data = {
        externalVisnetHubId,
        projectCode,
        substationCode,
        startDate,
        endDate,
        [group]: value
      };

      this.$store.dispatch(this.mappedFetchData, data);
    },
    changeCollapse() {
      this.showCollapse = !this.showCollapse;
    }
  }
};
</script>
